import React from "react";
import { Typography } from "@material-ui/core";
import { useStyles } from "./projectStyle";

export default function BaseWeight() {
  const classes = useStyles();
  var accentColor = "#DFF0EA";

  return (
    <div>
    <div className={classes.header} style={{ backgroundColor:  accentColor}}>
        <div className={classes.content} style={{paddingBottom: 0}}>
          <Typography variant="h2">Base Weight</Typography>
        </div>
        <img
          className={classes.headerImage}
          src="/assets/bw/feature.png"
          alt="base weight"
        />
      </div>
      <div className={classes.content}>
        <Typography variant="h2" className={classes.section}>
          Overview
        </Typography>
        <Typography>
          The essence of this project is to improve the process of packing:
          gathering items and personal effects and storing them efficiently.
          <br />
          <br />
          Packing for a trip is often as important as planning the trip itself.
          Forgetting to pack a map, or not knowing where you stored your lamp
          when it gets dark can sometimes ruin your trip.
          <br />
          <br />
          To avoid that kind of stress, it's best to have an easy and effective
          way to pack.
        </Typography>

        <Typography variant="h2" className={classes.section}>
          Problem
        </Typography>
        <Typography>
          While preparing for several trips, I found it difficult to organize
          the items that I was packing in a list. A simple list made it
          difficult to keep track of what was already in a bag and what needed
          to be added. Spreadsheets are quite powerful and can contain a lot of
          information but are complicated to setup and to use.
          <br />
          <br />
          Here are some problems I've run into:
          <ul>
            <li>
              How to handle repeated items that I pack at different times (some
              items are in the wash)?
            </li>
            <li>What weighs the most in my bag?</li>
            <li>Is my bag small enough for carry-on?</li>
            <li>Where did I store my headlamp?</li>
          </ul>
        </Typography>

        <Typography variant="h2" className={classes.section}>
          Process
        </Typography>
        <img
          className={classes.fullImage}
          src="/assets/bw/process.png"
          alt="process"
        />
        <Typography>
          This project is currently at the high fidelity prototype stage.
        </Typography>
      </div>
    </div>
  );
}
